/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function () {});

$(".img-btn input[type=radio]").on("change", function (event) {
  event.stopPropagation();
  if ($(this).prop("checked") == true) {
    $("#step1n").removeClass("disable_btn");
    setTimeout(function () {
      $("#step1n").trigger("click");
    }, 200);
  } else {
    $("#step1n").addClass("disable_btn");
  }
});

function bulkSelection(e) {
  e.stopPropagation();
  if ($(this).prop("checked") == true) {
    $("#step1n").prop("disabled", false);
    setTimeout(function () {
      $("#step1n").trigger("click");
    }, 200);
  } else {
    $("#step1n").prop("disabled", true);
  }
}
$(".img-btn input[type=radio]").on("click", bulkSelection);

// $(".ssize_opt input[type=radio]").on("change", function (event) {
//   event.stopPropagation();
//   if ($(this).prop("checked") == true) {
//     $("#step2n").prop("disabled", false);
//     $("#step2n").trigger("click");
//   } else {
//     $("#step2n").prop("disabled", true);
//   }
// });

// function sizeSelection(e) {
//   e.stopPropagation();
//   if ($(this).prop("checked") == true) {
//     $("#step2n").prop("disabled", false);
//     $("#step2n").trigger("click");
//   } else {
//     $("#step2n").prop("disabled", true);
//   }
// }

// $(".ssize_opt input[type=radio]").on("click", sizeSelection);

$("#step1n").click(function () {
  $("#step1").hide();
  $("#step2").show();
  $(".custom-product .btitle").hide();
});

  if ($(window).width() <= 768 ) {    
  $("#step2b").click(function () {
    $('html, body').animate({
      scrollTop: $(".custom-product").offset().top
    }, 500); // Adjust the scroll speed if needed
  });
  }


$("#step_new_btn").click(function () {
  $("#step1").hide();
  $("#step2").show();
  $(
    ".bulk_options .product-single__swatch__item:nth-child(2) [name='option-1']"
  ).trigger("click");
  $(".custom-product .btitle").hide();
});

$("#step2n").click(function () {
  $("#step2").hide();
  $("#step3").show();
});

$("#step2b").click(function () {
  $("#step1").show();
  $("#step2").hide();
  // $(".custom_content_box .product-single__content-text").hide();
  $(".custom-product .btitle").show();
});

$("#step3b").click(function () {
  $("#step2").show();
  $("#step3").hide();
});

$(".product-single__swatch__item input").on("click", function () {
  setTimeout(function () {
    var val1 = $(
      '.product-single__swatch[data-option-index="1"] input:checked'
    ).val();
    var val2 = $(
      '.product-single__swatch[data-option-index="2"] input:checked'
    ).val();
    var val3 = $(
      '.product-single__swatch[data-option-index="3"] input:checked'
    ).val();
    var data_v = val1 + " / " + val2 + " / " + val3;
    // console.log(data_v);
    $("#productSelect-1 option").each(function () {
      var select_d = $(this).data("title");
      var select_v = $(this).val();
      if (select_d == data_v) {
        // $(val1).val(select_v).trigger('change').change();

        $(".disable_btn").hide();
        $(".no_disable").show();
      }
    });

    $(".custom_content_box .product-single__content-text").each(function () {
      let v_title = $(this).data("v_title");
      let front_input = $('input[name="option-1"]:checked').val();
      if (front_input == v_title) {
        // console.log(v_title,"==",val1);
        $(".custom_content_box .product-single__content-text").hide();
        $(this).show();

        $(
          ".product-single__swatch[data-option-index='1'] .product-single__swatch__item input"
        ).each(function () {
          if (front_input == $(this).val()) {
            $(this).trigger("click");
            // $(this).prop("checked", true);
            // console.log($(this).val(),"new response");
          }
        });
      }
    });

    // console.log(val1);
  }, 200);
});

$(".product-single__swatch[data-option-index='1'] input").on(
  "click",
  function () {
    setTimeout(function () {
      $(".custom_content_box .product-single__content-text").each(function () {
        let v_title2 = $(this).data("v_title");
        let inner_input2 = $(
          '.product-single__swatch[data-option-index="1"] input:checked'
        ).val();
        if (inner_input2 == v_title2) {
          // console.log(v_title,"==",val1);
          $('input[name="option-1"]').prop("checked", false);
          $(".custom_content_box .product-single__content-text").hide();
          $(this).show();
        }
      });
    }, 200);
  }
);

// if(val1 == $(this).val()){
//   $(this).prop("checked", true);
//   $('input[name="option-1"]').prop("checked", false);
//   console.log($(this).val(),"new response");
// }

// $(".product-single__swatch[data-option-index='1'] .product-single__swatch__item input").each(function() {
//   if(val1 == $(this).val()){
//     $(this).prop("checked", true);
//     $('input[name="option-1"]').prop("checked", false);
//     console.log($(this).val(),"new response");
//   }
// });

$(".wholesale .wholesale_img .get_quote").on("click", function () {
  console.log("click", $(this).data("url"));
  $(".wholesale .home-inline__item")
    .find(".home-inline__media")
    .removeClass("bord_act");
  $("#ContactForm-product").val(
    $(this).parents(".home-inline__item").data("url")
  );
  $(this)
    .parents(".home-inline__item")
    .find(".home-inline__media")
    .addClass("bord_act");
  $(".page__contact-form").addClass("active");
  $(".page__contact-form").addClass("js-sr-loaded");
  $(".section__title.section__title--center").addClass("js-sr-loaded");
  $(".section__title.section__title--center").addClass("active");
  $(".page__contact-form").css("display", "block !important");

  $("html, body").animate(
    {
      scrollTop: $(".page__contact-form").offset().top,
    },
    1000
  );
});

// $(window).resize(function(){
//   $(".video_img .home-inline__media").height();
//   var img_height = $(".video_img .home-inline__media").height();
//     $(".custom_video .coffee_video").css("height", img_height);
//   console.log(img_height);
// });
